import React, { lazy, useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { getOpportunities, getInformation } from "../../store/actions/passiveIncomeActions";
import { getUserDetailsFromCookie } from "../../utils/getCookies";
import Card from "./Card";
import Paywall from "../payment/Paywall";
import PointProgress from "../layouts/PointProgress";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../../css/passive.income.scss";

const Info = lazy(() => import("@material-ui/icons/Info"));

const PassiveIncome = ({
  getOpportunities,
  getInformation, 
  opportunities,
  averageYieldPercentage,
  information,  
}) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) setUser(getUserDetailsFromCookie());
  }, [user]);

  useEffect(() => {
    const getData = async () => {
      await Promise.all([getOpportunities(), getInformation()]);
    };
  if (user && user.pplan > 4) {
    getData();
  } else {
    setLoading(false);
  }
  }, [getOpportunities, getInformation, user]);

  const chartOptions = {
    chart: {
      type: "pie",
      height: 300,
      width: 300,
      margin: [0, 0, 0, 0],
      backgroundColor: "transparent",
    },
    title: {
      useHTML: true,
      text: `
        <div style="text-align:center;">
          <div style="font-size:12px; color:#3de8a0;">30d APY</div>
          <div style="font-size:25px; font-weight:bold; color:#bcbcc1;">${averageYieldPercentage ? averageYieldPercentage.toFixed(2) : "0"}%</div>
        </div>
      `,
      align: "center",
      verticalAlign: "middle",
      y: 20,
    },
    tooltip: {
      formatter: function () {
        var name = this.point.name;
        var data = this.point.y;
        return `${data}% | ${name}`;
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: false,
      },
    },
    colorTheme: {
      fill: "none",
      stroke: "none",
    },
    series: [
      {
        data: (opportunities || []).map((item) => ({
        y: item.allocation, 
        name: item.opportunityName,
      })),
        size: "250px",
        innerSize: "60%",
      },
    ],
  };

  if (loading)
    return (
      <div id="loadingPage" className="visible">
        <PointProgress />
      </div>
    );

  if (!user || !user.pplan || user.pplan < 4) {
    return (
      <div className="fundamentos-modal">
        <Grid container direction="row" justify="center">
          <Grid item>
            <Paywall />
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <div className="passive-income-container">
      <div className="donut-chart-renda-passiva" style={{ position: "relative", }}>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          <div className="textGraph">
            <Info color="#fff" />
            <div className="bodyGraph">
              <p>
                {information?.text || "Informação indisponível."}
              </p>
            </div>
          </div>
      </div>

      {(opportunities || []).map((item, idx) => (
        <Card
          key={item.id}
          coins={item.coins}
          allocation ={item.allocation}
          contractAge={item.contractAge}
          currentTVL={item.currentTVL}
          description={item.description}
          externalLink={item.externalLink}           
          opportunityName={item.opportunityName}
          playLink={item.playLink}
          risk={item.risk}
          type={item.type}
          yieldPercent={item.yield}
          id={item.id}
          thumb={item.thumb}
        />
      ))}
    </div>
  );
}   

const mapStateToProps = (state) => ({
  opportunities: state.opportunities.opportunities,
  averageYieldPercentage: state.opportunities.averageYieldPercentage,
  information: state.opportunities.information,
});

export default connect(mapStateToProps, { getInformation, getOpportunities })(PassiveIncome);